var getQuestionById = function (_a) {
    var questionnaire = _a.questionnaire, id = _a.id;
    return questionnaire.find(function (question) { return question.id === id; });
};
export default getQuestionById;
//# sourceMappingURL=getQuestionById.js.map